import { yogaMainBlog } from "../data/data";
import { CarouselCardDetails_t } from "../components/Carousels/CarouselCard";
import U2LProto from "./U2LProto";
import NonStickyNavAndFooter from "./layout/NonStickyNavAndFooter";


export default function U2LPage() {
    const yogaMainBlogForYogaPage: CarouselCardDetails_t = yogaMainBlog
    delete yogaMainBlogForYogaPage.previous;
    delete yogaMainBlogForYogaPage.next;

    return (
        <NonStickyNavAndFooter>
            {/* <MainImageCarousel /> */}
            {/* <IntroductionWithImage img={nadaYogaImg}>
                {nadaYogaPageIntroduction}
                <br />
            </IntroductionWithImage> */}
           <U2LProto />
        </NonStickyNavAndFooter>
    )
}